import { z } from 'zod';
import { PartRequestByLineFilters } from '../stock-part-requests/types/stockPartRequestTypes';
import { BulkRequestTypeEnum } from './BulkRequestTypeEnum';

export const SelectionModelSchema = z.object({
  lineId: z.number().nullable(),
  selected: z.boolean(),
});

export const EditLocationSchema = SelectionModelSchema.extend({
  location: z.string().trim().max(255).nullable(),
});

export const EditOwnerSchema = SelectionModelSchema.extend({
  ownerId: z.number().nullable(),
});

export type BulkEditLocationRequest = z.infer<typeof EditLocationSchema>;
export type BulkEditOwnerRequest = z.infer<typeof EditOwnerSchema>;

export type SelectionModel = z.infer<typeof SelectionModelSchema>;
export type BulkEditLocationResponse = BulkEditLocationRequest;
export type BulkEditOwnerResponse = BulkEditOwnerRequest & { ownerName: string | null };

export type PartRequestBulkOptions = {
  selectedCount: number;
  bulkCount: number;
}

export type PartRequestBulkSelectionRequest = {
  isSelected: boolean;
  lineId: number | null;
  type: BulkRequestTypeEnum | null;
}

export type PartRequestBulkSelectionResponse = {
  selectedCount: number;
  isSelected: boolean;
  lineId: number | null;
}

export type PartRequestBulkItemDto = {
  id: number,
  lineId: number;
  isSelected: boolean | null,
  location: string | null,
  ownerId: number | null,
  ownerName: string | null;
  ordinalNumber: number | string,
  customerName: string | null,
  linkedEntityNumber: string | null,
  productNumber: string | null,
  availableInStock: number | null,
  partId: number | null,
  partsKitId: number | null,
  partsKitComponentId: number | null,
  partsKitComponentPartId: number | null,
  productName: string | null,
  requestedQuantity: number,
  purchaseOrderGenerationQuantity: number | null,
  allocatedQuantity: number;
  readyQuantity: number;
  stockQuantity: number;
  collectedQuantity: number;
  suppliers: string[];
  pricelists: string[]; // TBD: how to pick up this data?
  unitOfMeasure: number;
  costPrice: number | null;
  isReviewStockSourceLineSelectable: boolean;
  canQuantityBeCoveredByStock: boolean;
}

export type PartRequestCreateBulkRequest = {
  filter: PartRequestByLineFilters;
  operation: BulkRequestTypeEnum;
}

export type PartRequestSubmitBulkRequest = {
  operation: BulkRequestTypeEnum;
}

export type PartRequestSubmitBulkResponse = {
  purchaseOrderId?: number | null;
}
